import initialStepValidation from 'reducers/work-order/close-step-validation/initialStepValidation';
import { needsNoAccessReason } from '../../../utils/serviceTypeUtils';

export default (state, orderId) => {

    let currentValidation = state.getIn(['workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation']) || initialStepValidation;
    const noAccessReason = state.getIn([
        'workOrderDetails',
        orderId,
        'orderClose',
        'details',
        'closeOrderRequest',
        'commentRequest',
        'noAccessReasonId']);


    const orderStatus = state.getIn([
        'workOrderDetails',
        orderId,
        'orderClose',
        'details',
        'closeOrderRequest',
        'orderStatus'
    ]);

    const serviceTypeId = state.getIn([
        'workOrderDetails',
        orderId,
        'schedulingSystemDetails',
        'details',
        'serviceOrderInfoV2',
        'serviceTypeId',
    ]);

    if (orderStatus === 'NoAccess' && needsNoAccessReason(serviceTypeId)) {
        currentValidation = currentValidation.setIn([
            'noAccessReason', 'isValid'
        ], !!noAccessReason).setIn([
            'noAccessReason', 'message'
        ], noAccessReason ? null : 'Please select a Reason.');
    } else {
        currentValidation = currentValidation.setIn([
            'noAccessReason', 'isValid'
        ], true).setIn([
            'orderStatus', 'message'
        ], null);
    }

    return currentValidation;

};


// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/noAccessReasonValidator.js